import { watch, nextTick, Ref } from 'vue';

export function useDialogFocus(dialogModels: Ref<boolean>[]) {
  let lastFocusedElement: HTMLElement | null = null;

  function rememberFocus() {
    lastFocusedElement = document.activeElement as HTMLElement;
  }

  watch(
    dialogModels,
    async (values) => {
      const anyOpen = values.some((v) => v);
      if (!anyOpen && lastFocusedElement) {
        await nextTick();
        setTimeout(() => {
          lastFocusedElement?.focus();
          lastFocusedElement = null;
        }, 100);
      }
    },
    { immediate: true },
  );

  return {
    rememberFocus,
  };
}

export default useDialogFocus;
